import React, {useEffect, useMemo, useState} from "react"
import { DatePicker as Dtpicker, DateTimePicker as DTPicker } from '@material-ui/lab';
import { Grid, TextField } from "@material-ui/core";
import { TimePicker as TPicker } from '@material-ui/lab';
import moment from "moment";


export const dateToString = (vDate) => {
  const result = vDate && moment(vDate).format(); 
  return result;
}

export const DateTimePickerOqt = ({name, details = false, caption = "Fecha", formik, variant = "outlined", placeholder, onChange, minDate, invalidDateMessage, minDateMessage, maxDateMessage}) => {

  
  const formikValue = formik.values[name];

  const [value, setValue] = useState(!!formikValue ? moment(formikValue) : null);

  useEffect(()=>{
      formik.setFieldValue(name, dateToString(value));
  }, [value]);



  return (
    <div style={{ padding: 8 }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Dtpicker
            disabled={details}
            label={variant == "outlined" && caption}
            value={value}
            onChange={(value)=>{ 
              setValue(value)
            }}
            renderInput={(params) => <TextField {...params} helperText="" fullWidth variant={variant} />}
          />
        </Grid>
        <Grid item xs={6}>
          <TPicker
            disabled={details}
            label={variant == "outlined" && caption}
            value={value}
            onChange={(value)=>{ 
              setValue(value)
            }}
            renderInput={(params) => <TextField {...params} helperText="" fullWidth variant={variant} />}
          />
        </Grid>
      </Grid>
    </div>
  )
}

